module.exports = __webpack_public_path__ + "img/lyche.40458756.png";